import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import cn from 'classnames';
import { IProductShareTasks } from 'base/interfaces/product';
import { IconPoints } from '@pro/common/IconPoints';
import { useTrans } from 'base/utils/i18n';
import ShareTaskItem from '@base/product/ShareTaskItem';
import styles from './index.module.less';

type IProps = {
    shareData?: IProductShareTasks;
    open: boolean;
    onClosePopup: () => void;
    className?: string;
}

const isPhone = process.env.NEXT_PUBLIC_TERMINAL === 'm';


const ShareSuccessPopup: React.FC<IProps> = (props) => {
    const {
        shareData,
        open,
        onClosePopup,
        className
    } = props
    const { t } = useTrans();

    const resetTasks = shareData?.tasks?.filter(task => !task.taskDone) || []

    return (
        <Modal
            width={isPhone ? '100%' : '90%'}
            footer={false}
            centered
            className={cn(
                styles['task-success-popup'], className, 'wrapper-full'
            )}
            open={open}
            onCancel={() => onClosePopup()}
            destroyOnClose
            maskClosable={false}
        >
            <div className={'g-success-wrap text-center'}>
                <p className={'g-title'}>{t('web_common_congratulations')}</p>

                <div>
                    <IconPoints size={78}/>
                    <p className={'g-rewards-points'}>+ {shareData?.points || 0}</p>
                </div>

                {!!resetTasks?.length && (<>
                    <p className={'g-rest-tasks-title'}>-{t('web_shop_tutorial_more_task')}-</p>

                    <div className={cn(
                        'g-rest-tasks flex flex-center',
                        { 'flex-vertical': isPhone }
                    )}>
                        {resetTasks?.map((task, tIndex) => {
                            return (
                                <ShareTaskItem task={task}/>
                            )
                        })
                        }
                    </div>
                </>)}

            </div>
        </Modal>
    );
};

export default ShareSuccessPopup